import { HttpErrorResponse, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService {

  public token: string;
  constructor(private authService:AuthService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    this.token = localStorage.getItem('token');

    if (this.token == null) {
      this.token = '';
    }

    let request = req;
 
    if (this.token) {
      request = req.clone({
        setHeaders: {
          authorization:  this.token,
         
        }
        
      });


    }
 

    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
          this.authService.CerrarSesion();
        }

        return throwError(err);

      })
    );
  }
}
